<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
        <div class="row">
          <app-form-group label="Product name">
            <input [(ngModel)]="exemption.productName" id="productName" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Quantity (ton)">
            <input [(ngModel)]="exemption.quantity" id="quantity" type="number" maxlength="32" class="form-control"
                   required>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Method of transshipment">
            <app-select [(ngModel)]="exemption.transshipmentType" (ngModelChange)="resetTransshipmentTypeOther()"
                        id="transshipmentType"
                        [options]="transshipmentTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.transshipmentType == OTHER) {
            <app-form-group label="Other method of transshipment">
              <input [(ngModel)]="exemption.transshipmentTypeOther" id="transshipmentTypeOther" type="text"
                     maxlength="256" class="form-control">
            </app-form-group>
          }
        </div>
      </div>

      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Temporary storage on quayside">
            <app-select [(ngModel)]="exemption.storageType" (ngModelChange)="resetTemporaryStorageDates()"
                        id="storageType"
                        [options]="storageTypes" required>
            </app-select>
          </app-form-group>
        </div>

        @if (exemption.storageType == YES) {
          <div class="row">
            <app-form-group label="From">
              <app-date-field [(ngModel)]="exemption.from" id="from" required></app-date-field>
            </app-form-group>
            <app-form-group label="To">
              <app-date-field [(ngModel)]="exemption.to" id="to" required></app-date-field>
            </app-form-group>
          </div>
        }

        <div class="row">
          <app-form-group label="Truck max. axle weight (ton)">
            <input [(ngModel)]="exemption.maxAxleWeight" id="maxAxleWeight" type="number" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Use of forklift ?">
            <app-yes-no [(ngModel)]="exemption.useForklift" id="useForkLift" required></app-yes-no>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Expected quayside load (ton/m2)">
            <input [(ngModel)]="exemption.expectedQuaysideLoad" id="expectedQuaysideLoad" type="number"
                   maxlength="256" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Expected tensile strength of mooring lines">
            <input [(ngModel)]="exemption.expectedTensileStrength" id="expectedTensileStrength" type="text"
                   maxlength="256" class="form-control">
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Reason for request for exemption">
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
